import script from "./ProcedureTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcedureTypes.vue?vue&type=script&setup=true&lang=js"

import "./ProcedureTypes.vue?vue&type=style&index=0&id=2a227e1d&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a227e1d"]])

export default __exports__